let positionIconAnimation = {
    positionIcon: () => {

        // vars
        let positionIcon = ".positionIcon",
            gpsPoint = ".gpsPoint",
            tl = new TimelineMax({
                repeat: -1
            });

        tl.to(positionIcon, 2, {
            x: 40,
            ease: Elastic.easeOut.config(0.5, 0.3)
        })
        .to(positionIcon, 2, {
            x: 10,
            ease: Elastic.easeOut.config(0.5, 0.3)
        })
        .to(positionIcon, 2, {
            x: 0,
            ease: Elastic.easeOut.config(0.5, 0.3)
        })
        .to(positionIcon, 2, {
            y: -40,
            scale: 0.7,
            ease: Elastic.easeOut.config(0.5, 0.3)
        })
        .to(positionIcon, 2, {
            y: 0,
            scale: 1,
            ease: Elastic.easeOut.config(0.5, 0.3)
        });
    }

};

$(document).ready([positionIconAnimation.positionIcon]);
